export function Wordmark({ small = false }) {
    return (
        <div
            className="flex items-baseline gap-2"
            data-testid="brand-wordmark"
            aria-label="Project Mint"
        >
            <span
                className={`font-display font-black uppercase tracking-tighter leading-none text-[#f4f4f0] ${
                    small ? "text-lg" : "text-xl"
                }`}
            >
                PROJECT
            </span>
            <span
                className={`font-display font-black uppercase tracking-tighter leading-none text-[#ff4400] ${
                    small ? "text-lg" : "text-xl"
                }`}
            >
                MINT
            </span>
        </div>
    );
}
